module.exports = __webpack_public_path__ + "media/images/icon_facebook-960201d26907a648b0d6503c8079a888.png";